module.exports = __webpack_public_path__ + "img/kong-kubernetes.0032f97e.svg";